import { render, staticRenderFns } from "./ToggleCollapse.vue?vue&type=template&id=4fa59670&scoped=true"
import script from "./ToggleCollapse.vue?vue&type=script&lang=js"
export * from "./ToggleCollapse.vue?vue&type=script&lang=js"
import style0 from "./ToggleCollapse.vue?vue&type=style&index=0&id=4fa59670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa59670",
  null
  
)

export default component.exports